import { observable } from 'mobx';
import { createContext } from 'react';

type PanelList = {
  panelType: string;
  panelName: string;
  endpoint: string;
  width: number;
  row: number;
  backColor: string;
  textColor: string;
}[];

export class Dashboard {
  @observable panelList: PanelList = [
    {
      panelType: 'noPanel',
      panelName: 'No Panel',
      endpoint: '',
      width: 4,
      row: 0,
      backColor: 'darkBlue',
      textColor: 'white',
    },
    {
      panelType: 'chartPanel',
      panelName: 'Number of Lots',
      endpoint: 'http://localhost/length?asset=productOrder',
      width: 4,
      row: 1,
      backColor: 'black',
      textColor: 'white',
    },
    {
      panelType: 'fixedPanel',
      panelName: 'Number of Lots',
      endpoint: 'http://localhost/length?asset=productOrder',
      width: 2,
      row: 0,
      backColor: 'darkGreen',
      textColor: 'yellow',
    },
    {
      panelType: 'piePanel',
      panelName: 'Number of Orders',
      endpoint: 'http://localhost/length?asset=productOrder',
      width: 3,
      row: 1,
      backColor: 'white',
      textColor: 'blue',
    },
  ];

  @observable setPanelList = [];
}

export const DashboardContext = createContext(new Dashboard());
